export const paymentTypeOptions = [
    {
        label: "All Types",
        value: "all"
    },
    {
        label: "Medications",
        value: "medications"
    },
    {
        label: "Consultations",
        value: "consultations"
    },
    {
        label: "Appointments",
        value: "appointments"
    }
]

export const paymentStatusOptions = [
    {
        label: "All Status",
        value: "all"
    },
    {
        label: "Paid",
        value: "paid"
    },
    {
        label: "Not Paid",
        value: "not_paid"
    }
]

export const paymentDateFilters = [
    {
        label: "All Time",
        value: "all"
    },
    {
        label: "Today",
        value: "today"
    },
    {
        label: "This Week",
        value: "this_week"
    },
    {
        label: "This Month",
        value: "this_month"
    },
    {
        label: "This Year",
        value: "this_year"
    }
] 